import Legend from 'map/components/legend'
import CircleLoader from '@components/CircleLoader'
import styles from './styles.module.scss'

const ResultsList = ({ loading, hasResults, ratesError, children }) => (
    <div className={styles.resultList}>
        <Legend />
        {!hasResults && (
            <div className="d-flex justify-content-center mx-4 text-center">
                {!loading ? (
                    <T>map.results.none</T>
                ) : loading ? (
                    <>
                        <CircleLoader className="mr-2" size="small" />
                        <T>map.results.loading</T>
                    </>
                ) : ratesError ? (
                    <T>map.results.rates-error</T>
                ) : (
                    ''
                )}
            </div>
        )}
        {children}
    </div>
)

export default ResultsList
